import React from "react";
import commonClose from "../../../assets/img/commonClose.png";
import commonGuide from "../../../assets/img/commonGuide.png";
import useTheme from "../layoutscommon/DarkModeStorage";
import "../../../css/web/UserModalRenew.css";

function GuideModal({cartGuidePopup,     closeCartGuidePopup,     cartGuideHeader,     cartGuideContent,
                        orderGuidePopup,    closeOrderGuidePopup,    orderGuideHeader,    orderGuideContent,
                        offlineGuidePopup,  closeOfflineGuidePopup,  offlineGuideHeader,  offlineGuideContent,
                        transferGuidePopup, closeTransferGuidePopup, transferGuideHeader, transferGuideContent,
                        domesticGuidePopup, closeDomesticGuidePopup, domesticGuideHeader, domesticGuideContent,
                        deliveryGuidePopup, closeDeliveryGuidePopup, deliveryGuideHeader, deliveryGuideContent,
                        boosterGuidePopupShow, closeBoosterGuidePopup, boosterGuideHeader, boosterGuideContent}) {

    //Close
    const closeFunction = cartGuidePopup ? closeCartGuidePopup
        : orderGuidePopup ? closeOrderGuidePopup
            : offlineGuidePopup ? closeOfflineGuidePopup
                : transferGuidePopup ? closeTransferGuidePopup
                    : domesticGuidePopup ? closeDomesticGuidePopup
                        : deliveryGuidePopup ? closeDeliveryGuidePopup
                            : boosterGuidePopupShow ? closeBoosterGuidePopup
                            : null;

    //헤더
    const headerToDisplay = cartGuidePopup ? cartGuideHeader
        : orderGuidePopup ? orderGuideHeader
            : offlineGuidePopup ? offlineGuideHeader
                : transferGuidePopup ? transferGuideHeader
                    : domesticGuidePopup ? domesticGuideHeader
                        : deliveryGuidePopup ? deliveryGuideHeader
                            : boosterGuidePopupShow ? boosterGuideHeader
                            : "";

    //내용
    const contentToDisplay = cartGuidePopup ? cartGuideContent
        : orderGuidePopup ? orderGuideContent
            : offlineGuidePopup ? offlineGuideContent
                : transferGuidePopup ? transferGuideContent
                    : domesticGuidePopup ? domesticGuideContent
                        : deliveryGuidePopup ? deliveryGuideContent
                            : boosterGuidePopupShow ? boosterGuideContent
                            : "";

    const [theme] = useTheme();

    return(
        <div className="display-flex just-cont-center align-center position-fixed wd-100pc ht-100pc md-scope" data-theme={theme} style={{top:"0", left:"0", background:"var(--md-backdrop, rgba(0, 0, 0, 0.3))", zIndex:21}}>
            {/*<div style={{width: "500px", height: "350px", background: "white", boxShadow: "0 0 10px rgba(0, 0, 0, 0.5)", borderRadius: "6px"}}>*/}
            <div className="alertFrame">
                <div className="display-flex ht-20pc border-bottom-bt pd5">
                    <div className="ht-100pc wd-10pc display-flex just-cont-center align-center">
                        <img className="wd-auto ht-30" alt='' src={commonGuide}/>
                    </div>
                    <div className="display-flex align-center wd-80pc ht-100pc p-l-7">
                        <p className="font-t-title font-s-17">{headerToDisplay}</p>
                    </div>
                    <div className="user-center wd-10pc ht-100pc">
                        <img className="wd-30 ht-30 m-a-opc-07 c-point" onClick={closeFunction} src={commonClose} alt="close"/>
                    </div>
                </div>
                <div className="font-t-cont font-s-16 ht-80pc" style={{padding: "20px", whiteSpace: 'pre-line'}}>
                    {contentToDisplay}
                </div>
            </div>
        </div>
    )
}

export default GuideModal
